import builder from '../builder';
import PetsPaw from '../../streamline-icons/bold/pets-paw.svg';

export default builder('IconPetsPawBold', PetsPaw);
